export const API_CONFIG = {
  // BASE_URL: 'https://backend.onboarding.infinityhaul.com',
  onboardingDev: 'https://onbdev.infinityhaul.com',
  BASE_URL: 'https://onbdev.infinityhaul.com',
  TIMEOUT: 30000,
  ENDPOINTS: {
    FREE_VEHICLE: '/makeVehiclesFree',
    FREE_DRIVER: '/makeDriversFree',
    GET_FREE_DRIVERS: '/getFreeDrivers',
    GET_FREE_VEHICLES: '/getFreeVehicles',
    GENERATE_LOOP: '/generateLoop',
    GET_LOOP_DETAILS: '/getLoopDetails',
    GET_WAREHOUSE_LOCATIONS: '/getWarehouseLocations',
    GET_REQUEST_DETAILS: '/getRequestDetails'
  },
  ONBOARDING_URL: 'https://onboarding.infinityhaul.com'
};

